<template>
  <div class="camp_detail p_t">
    <TopHead title="营地介绍"></TopHead>
    <div class="cd_c">
      <div class="f_title">{{ydInfo.title}}</div>
      <div class="cdc_c" v-html="ydInfo.contentInfo"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CampDetail",
    data() {
      return {
        ydInfo:{},
      }
    },
    created(){
      this.queryContentByCode();
    },
    methods: {
      //营地介绍
      queryContentByCode(){
        this.$api.queryContentByCode(this.$route.query.contentCode).then(res => {
          this.ydInfo = JSON.parse(JSON.stringify(res.data));
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .cd_c{
    .cdc_c{
      margin-top: 18px;
    }
    padding: 26px 13px;
    ::v-deep img{
      max-width: 100% !important;
      height: auto;
    }
  }

</style>
